import React from 'react';
import {
  Link
} from 'react-router-dom';
import { NavBar } from '../css/_styledComponents';

export default function Footer () {
  return (
    <footer>
      <NavBar>
        <Link to="/">
          Home
        </Link>
        <Link to="/career">
          Career
          <span> &amp; Awards</span>
        </Link>
        <Link to="/stats">
          Statistics
        </Link>
        <Link to="/personalhistory">
          <span>Personal </span>
          History
        </Link>
      </NavBar>
    </footer>
  );
}
